var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgexport-7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.505,
    height: 17.505,
    viewBox: "0 0 17.505 17.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48630",
    "data-name": "Group 48630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48629",
    "data-name": "Group 48629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24719",
    "data-name": "Path 24719",
    d: "M8.752,0A8.752,8.752,0,1,0,17.5,8.752,8.748,8.748,0,0,0,8.752,0Zm0,16.284a7.531,7.531,0,1,1,7.531-7.531A7.54,7.54,0,0,1,8.752,16.284Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48632",
    "data-name": "Group 48632",
    transform: "translate(7.866 7.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48631",
    "data-name": "Group 48631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24720",
    "data-name": "Path 24720",
    d: "M230.946,213.4c-.518,0-.887.219-.887.542v4.389c0,.277.369.553.887.553.5,0,.9-.276.9-.553v-4.389C231.845,213.616,231.441,213.4,230.946,213.4Z",
    transform: "translate(-230.059 -213.397)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48634",
    "data-name": "Group 48634",
    transform: "translate(7.808 4.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48633",
    "data-name": "Group 48633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24721",
    "data-name": "Path 24721",
    d: "M229.32,134.208a.83.83,0,1,0,.933.818A.892.892,0,0,0,229.32,134.208Z",
    transform: "translate(-228.375 -134.208)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.86e9ae66c34b13f0deb3538f47f7d5e6.svg";
export { ForwardRef as ReactComponent };